export class ProgramTimings {
    public id: number;
    public beforeSchool: boolean;
    public afterSchool: boolean;
    public weekends: boolean;
    public summer: boolean;
    public schoolBreaksOrVacation: boolean;
    public afterHoursYouthProgramming: boolean;
}



// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/models/program/program-timings.ts